import axios from "axios";

import { apiDomain } from "../../store/constants";

const Webboard = {
  index(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  deleteRequests(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/delete-requests",
      method: "GET",
      params: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  save(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics",
      method: "POST",
      data: payload,
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  show(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/" + payload.id,
      method: "GET",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  comment(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/" + payload.topicId + "/comments",
      method: "POST",
      data: {
        content: payload.content,
        parent_id: payload.parent_id || null,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  requestDelete(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/" + payload.id + "/request-delete",
      method: "POST",
      data: {
        reason: payload.reason,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  destroy(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/" + payload.id,
      method: "DELETE",
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
  reviewDeleteRequest(payload) {
    return axios({
      url: apiDomain + "api/webboard-topics/delete-requests/" + payload.id + "/review",
      method: "POST",
      data: {
        decision: payload.decision,
        reason: payload.reason,
      },
    }).catch((e) => {
      console.log("Catch error \n", e.message);
      return e.response;
    });
  },
};

export default Webboard;
